module.exports = __webpack_public_path__ + "img/biopharm_icon.fc80931b.png";